<template>
  <section class="addCoursePage">
    <popup v-show="isShowAddCourse" :bread="`教材管理,课程管理,${addOrEdit === 'add'?'添加课程':'编辑课程'}`" @onBack="popup_back">
      <!-- <div slot="button">
        <el-button size="small" type="warning" @click="saveApprove" :disabled="savedisabled">保 存</el-button>
      </div> -->
      <infoUpDown :bread="'课程基础信息'">
        <el-form ref="ref_form" class="" :model="addCourseForm" :rules="addCourseFormRules" label-width="130px">
          <el-form-item label="教材名称">
            {{ tabsName }}
          </el-form-item>
          <el-form-item label="主题名称">
            {{ addOrEdit === 'add'?row.themeName:teachingThemeName }}
          </el-form-item>
          <el-form-item label="课程封页" prop="faceFile" style="margin-bottom: 25px;">
            <uploadAvatar :file-list.sync="addCourseForm.faceFile" />
          </el-form-item>

          <el-form-item label="课程类型" prop="curriculumType">
            <el-select v-model="addCourseForm.curriculumType" placeholder="请选择" :disabled="addOrEdit === 'edit'" clearable filterable style="width: 450px;" @change="curriculumTypeChange">
              <el-option
                v-for="item in curriculumTypeOptions"
                :key="item.dicCode"
                :label="item.dicName"
                :value="item.dicCode"
              />
            </el-select>
          </el-form-item>
          <el-form-item v-if="addCourseForm.curriculumType.startsWith('REVIEW')" label="关联常规课类型" prop="relationId">
            <el-select v-model="addCourseForm.relationId" placeholder="请选择" clearable filterable style="width: 450px;">
              <el-option
                v-for="item in relationCurriculumTypeOptions"
                :key="item.id"
                :label="item.curriculumName"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="课程步骤" prop="stageType">
            <el-checkbox-group v-model="addCourseForm.stageType" :disabled="addOrEdit === 'edit'">
              <el-checkbox v-for="item in stepAllOptions" :key="item.dicCode" :label="item.dicCode" :disabled="item.disabled">{{ item.dicName }}</el-checkbox>

            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="主题资料库" prop="themeIds">
            <el-cascader
              v-model="addCourseForm.themeIds"
              style="width: 450px;"
              :options="themeDataTree"
              placeholder="请选择主题资料库"
              clearable
              filterable
              collapse-tags
              :disabled="addOrEdit === 'edit'"
              :props="{ multiple: true, checkStrictly: false, emitPath: false, label: 'treeName', value: 'treeId' }"
            />
          </el-form-item>
          <el-form-item label="是否允许为试听课" prop="isAudition" label-width="140px">
            <el-switch
              v-model="addCourseForm.isAudition"
              active-value="1"
              inactive-value="0"
              active-color="#FCDA6F"
              inactive-color="#EAEBE8"
            />
          </el-form-item>
        </el-form>
      </infoUpDown>
      <div class="bottom-right-bar">
        <el-button v-if="addOrEdit === 'add'" type="success" @click="addCourseNextStep">下一步</el-button>
        <el-button v-if="addOrEdit === 'edit'" type="success" @click="updateCourseNextStep">下一步</el-button>
      </div>

    </popup>

    <!-- step 步骤 -->
    <!-- stepActive === ''?'':stepOptions[stepActive].dicName -->
    <popup v-show="isShowStep" :bread="`教材管理,课程管理,${addOrEdit === 'add'?'添加课程':'编辑课程'},${currentCourseName},${currentStepName}`" @onBack="popup_step_back">

      <template v-if="$store.state.courseStep.stepActive === ($store.state.courseStep.stepOptions.length - 1)" slot="button">
        <el-button type="success" @click="saveGameConfiguration()">保存游戏配置</el-button>
        <el-button type="success" @click="submitCourse()">提交发布课程</el-button>
      </template>
      <infoUpDown :is-show-title="false">
        <el-steps :active="stepActive" finish-status="success" class="stepAdd">
          <el-step v-for="(item, index) in stepOptions" :key="index" style="flex-basis:20%" :title="item.dicName" />
        </el-steps>
      </infoUpDown>
      <!-- 步骤的 动态组件 -->
      <component :is="componentId" ref="ref_step" :current-course-name="currentCourseName" :timestamp="timestamp" @preStep="preStep" @nextStep="nextStep" />

    </popup>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import uploadAvatar from '@/components/Upload/uploadAvatar'
import { getDictoryInfoByCode } from '@/api/api_common'
import { addCurriculum, updateCurriculum, getTeachingAndThemeList, getCurriculumInfo, addCurriculumSubmit, getReviewCurriculumInfo } from '@api/courseManagement/api_courseManagement'
import { step1, step2, step3, step4, step5 } from './index.js'
export default {
  components: {
    uploadAvatar,
    step1,
    step2,
    step3,
    step4,
    step5
  },
  props: {
    // 点击添加课程时，为主题行；点击编辑课程时，为课程行
    row: {
      type: Object,
      default: null
    },
    materialId: {
      type: Number,
      default: -1
    },
    tabsOptions: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      isShowAddCourse: false,
      timestamp: 0,
      curriculumTypeOptions: [],
      // 关联常规课类型
      relationCurriculumTypeOptions: [],

      themeDataTree: [],
      // 点击编辑课程时，从接口处获得主题名称
      teachingThemeName: '',
      teachingThemeId: '',
      addCourseForm: {
        faceFile: [],
        curriculumType: '',
        // stageType: ['Lead-in', 'Highlights', 'Speaking', 'Quiz'],
        stageType: [],
        themeIds: [],
        relationId: '',
        isAudition: '0'
      },
      addCourseFormRules: {
        faceFile: [{ type: 'array', required: true, message: '请上传课程封页', trigger: 'change' }],
        curriculumType: [{ required: true, message: '请选择课程名称', trigger: 'change' }],
        relationId: [{ required: true, message: '请选择关联常规课名称', trigger: 'change' }],
        stageType: [{ type: 'array', required: true, message: '请选择课程步骤', trigger: 'change' }],
        themeIds: [{ type: 'array', required: true, message: '请选择主题资料库', trigger: 'change' }]
      },

      // step 弹窗变量
      isShowStep: false,
      // componentId: 'step1',
      stepActive: 100,
      stepAllOptions: [
        { dicCode: 'Lead-in', dicName: 'Lead-in', step: 'step1', disabled: true },
        { dicCode: 'Highlights', dicName: 'Highlights', step: 'step4', disabled: false },
        { dicCode: 'Video', dicName: 'Video', step: 'step4', disabled: false },
        { dicCode: 'Story', dicName: 'Story', step: 'step4', disabled: false },
        { dicCode: 'Speaking', dicName: 'Speaking', step: 'step4', disabled: true },
        { dicCode: 'Quiz', dicName: 'Quiz', step: 'step5', disabled: true }
      ]

    }
  },
  computed: {
    ...mapState('courseStep', ['addOrEdit', 'courseData']),
    stepOptions () {
      return this.stepAllOptions.filter(item => {
        return this.addCourseForm.stageType.includes(item.dicCode)
      })
    },
    componentId () {
      if (this.stepActive === 100) {
        return ''
      } else {
        return this.stepOptions[this.stepActive].step
      }
    },
    tabsName () {
      let str = ''
      for (const item of this.tabsOptions) {
        if (item.id === this.materialId) {
          str = item.teachingName
        }
      }
      return str
    },

    currentCourseName () {
      const arr = this.curriculumTypeOptions
      let str = ''
      for (const item of arr) {
        if (this.addCourseForm.curriculumType === item.dicCode) {
          str = item.dicName
          break
        }
      }
      return str
    },
    currentStepName () {
      let str = ''
      if (Number.isFinite(this.stepActive) && this.stepActive < 6) {
        str = this.stepOptions[this.stepActive].dicName
      }
      return str
    }
  },
  watch: {

  },
  created () {
    this.getOptions()
  },
  methods: {
    getOptions () {
      getDictoryInfoByCode('COURSE_DEFINITION').then(res => { this.curriculumTypeOptions = res })
      getTeachingAndThemeList().then(res => {
        res.forEach(item => {
          item.children.forEach(item2 => {
            item2.children = null
          })
        })
        this.themeDataTree = res
      })
    },
    async getCourseDetail () {
      await getCurriculumInfo({ curriculumId: this.row.id }).then(res => {
        this.teachingThemeName = res.teachingThemeName
        this.teachingThemeId = res.teachingThemeId
        this.addCourseForm.faceFile = [{ name: res.fileOriginalName, url: res.filePath, id: res.fileId }]
        this.addCourseForm.curriculumType = res.curriculumType
        this.addCourseForm.relationId = res.relationId
        this.addCourseForm.themeIds = res.themeIds.split(',')
        this.addCourseForm.isAudition = res.isAudition
        this.curriculumTypeChange(this.addCourseForm.curriculumType)
        this.addCourseForm.stageType = res.stepIds.split(',')
      })
    },
    curriculumTypeChange (val) {
      if (val === 'REVIEWWORDS' || val === 'REVIEWSIGHTWORDS' || val === 'REVIEWSENTENCE' || val === 'REVIEWPHONICS') {
        this.addCourseForm.stageType = ['Lead-in', 'Highlights', 'Quiz']
        this.stepAllOptions = [
          { dicCode: 'Lead-in', dicName: 'Lead-in', step: 'step1', disabled: true },
          { dicCode: 'Highlights', dicName: 'Highlights', step: 'step4', disabled: true },
          { dicCode: 'Quiz', dicName: 'Quiz', step: 'step5', disabled: true }
        ]
      } else if (val === 'REVIEWREADING') {
        this.addCourseForm.stageType = ['Lead-in', 'Highlights', 'Story', 'Quiz']
        this.stepAllOptions = [
          { dicCode: 'Lead-in', dicName: 'Lead-in', step: 'step1', disabled: true },
          { dicCode: 'Highlights', dicName: 'Highlights', step: 'step4', disabled: true },
          { dicCode: 'Story', dicName: 'Story', step: 'step4', disabled: false },
          { dicCode: 'Quiz', dicName: 'Quiz', step: 'step5', disabled: true }
        ]
      } else if (val === 'TESTWORDS' || val === 'TESTSIGHTWORDS' || val === 'TESTSENTENCE' || val === 'TESTPHONICS' || val === 'TESTREADING') {
        this.addCourseForm.stageType = ['Quiz']
        this.stepAllOptions = [
          { dicCode: 'Quiz', dicName: 'Quiz', step: 'step5', disabled: true }
        ]
      } else {
        this.addCourseForm.stageType = ['Lead-in', 'Highlights', 'Speaking', 'Quiz']
        this.stepAllOptions = [
          { dicCode: 'Lead-in', dicName: 'Lead-in', step: 'step1', disabled: true },
          { dicCode: 'Highlights', dicName: 'Highlights', step: 'step4', disabled: false },
          { dicCode: 'Video', dicName: 'Video', step: 'step4', disabled: false },
          { dicCode: 'Story', dicName: 'Story', step: 'step4', disabled: false },
          { dicCode: 'Speaking', dicName: 'Speaking', step: 'step4', disabled: true },
          { dicCode: 'Quiz', dicName: 'Quiz', step: 'step5', disabled: true }
        ]
      }

      // 选中复习课类型时，查询 关联常规课
      const str = val || ''
      if (str.startsWith('REVIEW')) {
        this.getReviewCurriculumInfo(val)
      }
    },
    // 查询关联 常规课类型
    getReviewCurriculumInfo (curriculumType) {
      const themeId = this.addOrEdit === 'add' ? this.row.id : this.teachingThemeId

      getReviewCurriculumInfo({
        themeId,
        curriculumType
      }).then(res => {
        this.relationCurriculumTypeOptions = res
        const arrLength = this.relationCurriculumTypeOptions.length
        if (arrLength > 0) {
          // 新增时，默认取常规课最后一条数据
          if (this.addOrEdit === 'add') {
            this.addCourseForm.relationId = this.relationCurriculumTypeOptions[arrLength - 1].id
          }
        } else {
          this.addCourseForm.relationId = ''
        }
      })
    },
    // 返回
    popup_back () {
      this.stepActive = 100
      this.curriculumTypeChange()
      this.$refs.ref_form.resetFields()
      this.isShowAddCourse = false
      this.$emit('resetFetchData')
    },

    popup_step_back () {
      this.stepActive = 100
      this.$refs.ref_form.resetFields()
      this.isShowStep = false
      this.isShowAddCourse = false
      this.$emit('resetFetchData')
      this.$store.commit('courseStep/SET_currentClickData', {})
    },

    resetComponent (componentId) {
      this.componentId = componentId
      this.$nextTick(() => {
        this.timestamp = Date.now()
      })
    },
    addCourseNextStep () {
      this.$refs.ref_form.validate(valid => {
        if (!valid) { return false }

        const params = {
          ...this.addCourseForm
        }
        params.faceFileId = this.addCourseForm.faceFile[0].id
        params.materialId = this.materialId
        params.themeId = this.row.id
        addCurriculum(params).then(res => {
          const courseData = {
            materialId: this.materialId,
            themeId: this.row.id,
            teachingCurriculumId: res.teachingCurriculumId,
            curriculumType: this.addCourseForm.curriculumType,
            themeIds: this.addCourseForm.themeIds
          }
          this.$store.commit('courseStep/SET_courseData', courseData)
          this.$store.commit('courseStep/SET_stepOptions', this.stepOptions)

          this.stepActive = 0
          this.$store.commit('courseStep/SET_stepActive', this.stepActive)
          this.isShowStep = true
          this.$nextTick(() => {
            this.timestamp = Date.now()
          })
        })
      })
    },
    updateCourseNextStep () {
      this.$refs.ref_form.validate(valid => {
        if (!valid) { return false }
        const params = {
          curriculumId: this.row.id,
          faceFileId: this.addCourseForm.faceFile[0].id,
          isAudition: this.addCourseForm.isAudition,
          relationId: this.addCourseForm.relationId
        }

        updateCurriculum(params).then(res => {
          const courseData = {
            materialId: this.materialId,
            // themeId: this.row.id,
            teachingCurriculumId: res.teachingCurriculumId,
            curriculumType: this.addCourseForm.curriculumType,
            themeIds: this.addCourseForm.themeIds
          }
          this.$store.commit('courseStep/SET_courseData', courseData)
          this.$store.commit('courseStep/SET_stepOptions', this.stepOptions)
          this.stepActive = 0
          this.$store.commit('courseStep/SET_stepActive', this.stepActive)
          this.isShowStep = true
          this.$nextTick(() => {
            this.timestamp = Date.now()
          })
        })
      })
    },
    preStep () {
      this.stepActive--
      this.$store.commit('courseStep/SET_stepActive', this.stepActive)
      this.$store.commit('courseStep/SET_currentClickData', {})
      this.$nextTick(() => {
        this.timestamp = Date.now()
      })
    },
    nextStep (formName) {
      this.stepActive++
      this.$store.commit('courseStep/SET_stepActive', this.stepActive)
      this.$store.commit('courseStep/SET_currentClickData', {})
      this.$nextTick(() => {
        this.timestamp = Date.now()
      })
    },

    // 保存游戏配置 按钮点击事件
    saveGameConfiguration () {
      // 调用子组件 保存游戏方法
      this.$refs.ref_step.saveGameConfiguration()
    },

    // 所有步骤 课程提交接口
    submitCourse () {
      //0301
      //检查配置了游戏的是否勾选使用游戏
      console.log("======走到发布前的判断")
      if(!this.$refs.ref_step.checkIsSelectGame()){
        console.log("======一个都没选")
          return false
      }
      console.log("======走到判断后，可以正确提交")
      /////
      addCurriculumSubmit({ curriculumId: this.courseData.teachingCurriculumId }).then(res => {
        this.$message.success('课程提交成功')
        // 关闭所有弹窗 并刷新列表
        this.popup_step_back()
      })
    }

  }
}
</script>

<style lang='scss'>
.stepAdd{ // 步骤条
  padding:24px 50px 0 0;
  .el-step__main{position: absolute;left: 24px;top: -2px;background-color: white;padding: 0 20px;}
  .el-step__icon{width: 32px;height: 32px;}
  .el-step.is-horizontal .el-step__line{background-color: #EEEEEE;height: 4px;top: 15px;right: 16px;}
  .el-step__title.is-wait{color: #C3C2BF;}
  .el-step__title.is-process{color: #FDC100;font-weight: normal;}
  .el-step__title.is-success{color: #898884;font-weight: normal;}
  .el-step__head.is-wait{color: #C3C2BF;border-color: #C3C2BF;}
  .el-step__head.is-process{
    border-color: #FCDA6F;color:#45433D;
    .el-step__icon.is-text{background-color: #FCDA6F;}
  }
  .el-step__head.is-success{
    border-color: #898884;color:#898884;
    .el-step__line{border-color: #EEEEEE;}
  }
  .el-step__icon-inner{font-weight: normal;}

}
.bottom-right-bar{
  position: fixed;
  background: #FCFCFC;
  left: 200px;
  bottom: 0;
  right: 0;
  z-index: 1;
  padding: 10px 24px 10px 0;
}

.checked-container{
  display: flex;
  .step-el-tabs{
    min-width: 500px;
    flex-shrink: 0;
    flex: 1;
    margin-right: 30px;
  }
  .singleWordDetailComponent{
    flex: 1;
    min-width: 485px;
  }
}
</style>
